import { createFileRoute, redirect } from "@tanstack/react-router";

/** The tank board is the home page now. */
export const Route = createFileRoute("/fermentations/board")({
  beforeLoad: () => {
    throw redirect({ to: "/" });
  },
});
